import React from 'react';
import ReactECharts from 'echarts-for-react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBarChart2 } = FiIcons;

const DepartmentComplianceChart = ({ records = [], learners = [] }) => {
  const getDeptData = () => {
    const depts = [...new Set(learners.map(l => l?.department).filter(Boolean))];
    return depts.map(dept => {
      const ids = learners.filter(l => l?.department === dept).map(l => String(l?.id));
      const recs = records.filter(r => ids.includes(String(r?.learnerId)));
      const compliant = recs.filter(r => r?.complianceStatus === 'Compliant').length;
      const overdue = recs.filter(r => r?.complianceStatus === 'Overdue').length;
      const inProg = recs.filter(r => ['In Progress', 'At Risk', 'Not Started'].includes(r?.complianceStatus)).length;
      const pct = recs.length ? Math.round((compliant / recs.length) * 100) : 0;
      return { dept, pct, compliant, overdue, inProg, total: recs.length };
    }).sort((a, b) => b.pct - a.pct);
  };
  
  const data = getDeptData();

  const barOption = {
    tooltip: { trigger: 'axis', formatter: (p) => `${p[0].name}<br/>Compliance: <b>${p[0].value}%</b>` },
    grid: { left: '3%', right: '5%', top: '5%', bottom: '5%', containLabel: true },
    xAxis: { type: 'value', max: 100, axisLabel: { formatter: '{value}%', fontSize: 10 }, splitLine: { lineStyle: { color: '#f1f5f9' } } },
    yAxis: { type: 'category', data: [...data].reverse().map(d => d.dept), axisLabel: { fontSize: 11 } },
    series: [{
      type: 'bar', barMaxWidth: 22,
      data: [...data].reverse().map(d => ({
        value: d.pct,
        itemStyle: { color: d.pct >= 80 ? '#10b981' : d.pct >= 60 ? '#f59e0b' : '#ef4444', borderRadius: [0, 6, 6, 0] }
      }))
    }]
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-4">
        <SafeIcon icon={FiBarChart2} className="text-blue-500" />
        <h3 className="text-sm font-semibold text-slate-700">Department Compliance Rate</h3>
      </div>
      <ReactECharts option={barOption} style={{ height: 220 }} />
      <div className="mt-4 space-y-2">
        {data.length === 0 && <p className="text-center text-sm text-slate-400">No department data available.</p>}
        {data.map(d => (
          <div key={d.dept} className="flex items-center justify-between text-xs">
            <div className="flex items-center gap-2 w-32 flex-shrink-0">
              <div className={`w-2 h-2 rounded-full flex-shrink-0 ${d.pct >= 80 ? 'bg-emerald-500' : d.pct >= 60 ? 'bg-amber-500' : 'bg-red-500'}`} />
              <span className="text-slate-600 font-medium truncate">{d.dept}</span>
            </div>
            <div className="flex-1 mx-3 bg-slate-100 rounded-full h-1.5">
              <div className={`h-1.5 rounded-full ${d.pct >= 80 ? 'bg-emerald-500' : d.pct >= 60 ? 'bg-amber-500' : 'bg-red-500'}`} style={{ width: `${d.pct}%` }} />
            </div>
            <span className={`font-bold w-10 text-right ${d.pct >= 80 ? 'text-emerald-600' : d.pct >= 60 ? 'text-amber-600' : 'text-red-600'}`}>{d.pct}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DepartmentComplianceChart;